import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2152eb52"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=2152eb52&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2152eb52')) {
      api.createRecord('2152eb52', component.options)
    } else {
      api.reload('2152eb52', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2152eb52", function () {
      api.rerender('2152eb52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DateCustoms/DateTime/main.vue"
export default component.exports